import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Formik, Form } from "formik"; // import PropTypes from 'prop-types';

import * as Yup from "yup";
import { Button, Grid, SubmitButton, DocumentInfo, DocumentItems, makeStyles, Paper, Divider, Skeleton, numeral, Typography, setLocale } from "../../..";
import { Debug } from "../../../Molecules/Forms/Debug";
import selects from "../../../assets/selects";
import { useEffect } from "react";
var invoiceSchema = Yup.object().shape({
  type: Yup.string(),
  franchise: Yup.string().when("type", {
    is: "in",
    then: Yup.string().required("Required field")
  }),
  client: Yup.string().when("type", {
    is: "out",
    then: Yup.string().required("Required field")
  }),
  serie_id: Yup.string().required("Required field"),
  category: Yup.string().required("Required field"),
  payment_method_id: Yup.string().required("Required field"),
  date: Yup.date()["default"](function () {
    return new Date();
  }),
  due_date: Yup.date()["default"](function () {
    return new Date();
  }),
  items: Yup.array().of(Yup.object().shape({
    name: Yup.string(),
    // these constraints take precedence
    description: Yup.string(),
    // these constraints take precedence
    qty: Yup.number().required(),
    price: Yup.number().required(),
    tax: Yup.string(),
    // these constraints take precedence
    total: Yup.number()
  }))
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      height: "100vh"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    foot: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      "padding-right": "30px",
      "z-index": 99
    },
    footer: {
      display: "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    },
    box: {
      display: "flex",
      "flex-direction": "column",
      padding: "30px",
      "margin-left": "15px"
    },
    actions: {
      display: "flex",
      padding: "15px",
      "justify-content": "flex-end"
    },
    form: {
      width: "100%"
    }
  };
});

var EditInvoice = function EditInvoice(_ref) {
  var info = _ref.info,
      invoice = _ref.invoice,
      type = _ref.type,
      variant = _ref.variant,
      translation = _ref.translation,
      editInvoice = _ref.editInvoice,
      drawerOpen = _ref.drawerOpen,
      handleCancel = _ref.handleCancel,
      franchise = _ref.franchise,
      handleCreateClient = _ref.handleCreateClient,
      createBillingInfo = _ref.createBillingInfo,
      locale = _ref.locale;
  var series = info.series,
      projects = info.projects,
      clients = info.clients,
      payment_methods = info.payment_methods;
  var classes = useStyles();
  useEffect(function () {
    setLocale(locale);
  }, [locale]);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      total = _useState2[0],
      setTotal = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      subtotal = _useState4[0],
      setSubtotal = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      tax = _useState6[0],
      setTax = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      irpf = _useState8[0],
      setIrpf = _useState8[1];

  var calculateTotal = function calculateTotal(values) {
    // console.log("calculateTotal Edit", values);
    values.items && values.items.forEach(function (item) {
      item.subtotal = item.qty * item.price;
      var tax = translation ? translation.selects.taxes.items.find(function (tax) {
        return tax.value === item.tax;
      }) : selects.taxes.find(function (tax) {
        return tax.value === item.tax;
      });
      item.total = tax ? item.qty * item.price * (1 + tax.percentage) : item.qty * item.price;
    });
    values.subtotal = values.items && values.items.reduce(function (acc, item) {
      acc += item.qty * item.price;
      return acc;
    }, 0);
    values.total = values.items && values.items.reduce(function (acc, item) {
      acc += item.total;
      return acc;
    }, 0);
    values.tax = values.items && values.items.reduce(function (acc, item) {
      var tax = translation ? translation.selects.taxes.items.find(function (tax) {
        return tax.value === item.tax;
      }) : selects.taxes.find(function (tax) {
        return tax.value === item.tax;
      });
      acc += tax ? tax.percentage * item.qty * item.price : 0;
      return acc;
    }, 0);
    setSubtotal(values.subtotal);
    setTax(values.tax);
    setIrpf(values.items && -values.subtotal * (values.irpf / 100));
    setTotal(!isNaN(parseFloat(irpf)) ? values.total + irpf : values.total);
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, variant === "edit" && invoice && info ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: invoice,
    validationSchema: invoiceSchema,
    onSubmit: function onSubmit(values, _ref2) {
      var resetForm = _ref2.resetForm;
      editInvoice(_objectSpread(_objectSpread({}, values), {}, {
        tax: tax,
        total: total,
        subtotal: subtotal
      }));
    },
    render: function render(_ref3) {
      var values = _ref3.values,
          isValid = _ref3.isValid,
          isSubmitting = _ref3.isSubmitting;
      values && values.items && calculateTotal(values);
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "edit-invoice",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "large",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: handleCancel
      }, translation ? translation.buttons.cancel : "Cancel"), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "large",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, variant === "add" ? translation ? translation.buttons.add : "Crear" : translation ? translation.buttons.save : "Save"), /*#__PURE__*/React.createElement(DocumentInfo, {
        mode: variant,
        translation: translation ? translation : null,
        series: series,
        type: type,
        values: values,
        clients: clients,
        franchise: franchise,
        handleCreateClient: handleCreateClient,
        createBillingInfo: createBillingInfo
      }), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(DocumentItems, {
        mode: variant,
        values: values,
        translation: translation ? translation : null,
        paymentMethods: payment_methods,
        projects: projects,
        franchise: franchise
      }), /*#__PURE__*/React.createElement(Divider, null));
    }
  }) : /*#__PURE__*/React.createElement(Skeleton, null), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.foot
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: classes.footer,
    style: {
      width: drawerOpen ? "80%" : "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Subtotal: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, numeral(subtotal).format("0,0[.]00 $"))), irpf !== 0 && irpf !== "" && /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "IRPF: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, numeral(irpf).format("0,0[.]00 $"))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Tax: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, numeral(tax).format("0,0[.]00 $"))), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    variant: "middle"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Total: "), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, numeral(total).format("0,0[.]00 $"))))))];
};

export { EditInvoice };